export const SET_DATA = "project/SET_DATA";
export const RESET = "project/RESET";
